import { filter, tap, takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@shared/services/auth/auth.service';
import { IAppState } from '@state/reducers/app/app.reducer';
import { IState } from '@state/state.module';
import { Observable, ReplaySubject } from 'rxjs';
import { SettingsService } from '../../../core/settings/settings.service';
import { UserblockService } from './userblock.service';
import { PrimeNGConfig } from 'primeng/api';
import { UsersService } from '@shared/services/api/legacy/users-service/users.service';
import * as moment from 'moment';

class Profile {
    public id: string;
    public name: string;
    public firstName: string;
    public languageId: string;
    public pictureUrl: string;
    public jobTitle: string;
}

@Component({
    selector: 'app-userblock',
    templateUrl: './userblock.component.html',
    styleUrls: ['./userblock.component.scss']
})
export class UserblockComponent implements OnInit, OnDestroy {
    private state$: Observable<IAppState>;
    private destroy$ = new ReplaySubject<boolean>();
    public user: any;
    public profile: Profile = new Profile();

    public value: any = { };
    public disabledVar = '0';
    public disabled = false;

    public get disabledV(): string {
        return this.disabledVar;
    }

    public set disabledV(value: string) {
        this.disabledVar = value;
        this.disabled = this.disabledVar === '1';
    }

    public selected(value: any): void {
        // selected
    }

    public removed(value: any): void {
        // removed
    }

    public typed(value: any): void {
        // typed
    }

    public refreshValue(value: any): void {
        this.value = value;
    }

    constructor(
        public userblockService: UserblockService,
        public settings: SettingsService,
        private authService: AuthService,
        private store: Store<IState>,
        private translateService: TranslateService,
        private router: Router,
        private primeNgConfig: PrimeNGConfig,
        private usersService: UsersService) { }

    public ngOnInit() {
        this.state$ = this.store.select(x => x.app);
        this.state$.pipe(
            takeUntil(this.destroy$),
            tap(x => {
                this.profile = x.profile;
            }),)
            .subscribe();

        this.state$.pipe(
            takeUntil(this.destroy$),
            filter(x => !!x && !!x.profile && !! x.profile.languageId),
            tap(x => {
                this.translateService.use(x.profile.languageId?.substring(0, 2));

                // Set locale
                moment.locale(x.profile.localeId);
            }))
            .subscribe(() => {
                // Change PrimeNG locale
                this.translateService.get('primeng').subscribe(res => this.primeNgConfig.setTranslation(res));
            });
    }

    public ngOnDestroy() {
        this.destroy$.next(true);
    }
}
